export const setFormErrors: (errors: any, setError: any) => void = (
  errors: any,
  setError: any
) => {
  // setError is the form setError method
  try {
    setError(
      errors.field,
      { type: "custom", message: errors.message },
      { shouldFocus: true }
    );
  } catch (error) {
    console.log("Error trying to set UI errors  : ", error);
  }
};
